"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PricingCalculationBox = exports.PricingCalculation = exports.Introduction = exports.TotalPrice = exports.OriginalPrice = exports.PricingTotal = void 0;
const polished_1 = require("polished");
const styled_components_1 = __importDefault(require("styled-components"));
exports.PricingTotal = styled_components_1.default.div `
	border-top: 1px solid ${props => (0, polished_1.transparentize)(0.85, props.theme.color.black)};
	margin: 2em 0 0;
	padding: 2em 0 0;
	width: 100%;
	justify-content: center;
`;
exports.OriginalPrice = styled_components_1.default.div `
	text-align: center;
	color: ${props => (0, polished_1.transparentize)(0.1, props.theme.color.gray6)};
	font-size: 0.8em;
	padding: 0 2em 0;

	small {
		font-size: 0.9em;
	}
`;
exports.TotalPrice = styled_components_1.default.div `
	text-align: center;
	color: ${props => (0, polished_1.transparentize)(0.1, props.theme.color.black)};
	font-size: 1.3em;
	padding: 0.5em 2em 1em;

	strong {
		color: ${props => props.theme.color.success};
	}

	small {
		color: ${props => (0, polished_1.transparentize)(0.6, props.theme.color.black)};
		font-size: 0.9em;
	}
`;
exports.Introduction = styled_components_1.default.div `
	text-align: center;
	color: ${props => props.theme.color.gray6};
	font-size: 1.2em;
	padding: 1em 2em 0;
`;
exports.PricingCalculation = styled_components_1.default.div `
	display: flex;
	justify-content: center;
	padding: 0;
`;
exports.PricingCalculationBox = styled_components_1.default.div `
	display: flex;
	width: 50%;
	justify-content: center;

	dl {
		margin: 0;
	}
	dt {
		color: ${props => (0, polished_1.transparentize)(0.4, props.theme.color.black)};
		font-size: 0.9em;
		font-weight: 700;
	}
	dd {
		color: ${props => props.theme.color.black};
		font-size: 2em;
		margin: 0;

		small {
			display: block;
			color: ${props => props.theme.color.gray6};
			font-size: 0.5em;
		}
	}
`;
